import { isDefined } from "@prismicio/editor-support/Type"
import {
  type RichText,
  RichTextNodeType,
} from "@prismicio/types-internal/lib/customtypes"

import {
  type ExtensionPlaceholder,
  type NodeExtension,
  NodeType,
} from "../models"
import { default as Document } from "./Document"
import { default as HardBreak } from "./HardBreak"
import { default as ListItem } from "./ListItem"
import { default as Placeholder } from "./Placeholder"
import { SlashCommands } from "./SlashCommands"
import { default as Text } from "./Text"

export function CoreComponents(
  field: RichText,
  nodeExtensions: NodeExtension[],
) {
  const allPrismicNodeTypes = nodeExtensions
    .map((e) => e.richTextNodeTypes)
    .flat()

  const placeholderByNodeType = getPlaceHolderByNodeType(nodeExtensions)

  const placeHolderProps = {
    placeholderByNodeType,
    unfocusedPlaceholder: field.config?.placeholder,
    nodeExtensions,
  }

  const withLists =
    allPrismicNodeTypes.includes(RichTextNodeType.orderedList) ||
    allPrismicNodeTypes.includes(RichTextNodeType.list)

  const richTextComponents = [
    Document.component(field.config?.single === undefined),
    Text.component,
    HardBreak.component,
    Placeholder(placeHolderProps),
    withLists ? ListItem.component : undefined,
    SlashCommands.configure({ nodeTypes: allPrismicNodeTypes }),
  ]

  return richTextComponents.filter(isDefined)
}

function getPlaceHolderByNodeType(nodes: NodeExtension[]) {
  return nodes.reduce<Record<string, ExtensionPlaceholder>>((acc, node) => {
    if (node.nodeType === NodeType.Text) acc[node.name] = node.placeholder
    return acc
  }, {})
}

export { Document, HardBreak, ListItem, Text }
